<template lang="pug">
	EditableLabelField.web-services--date-editor.flex-row.space.flex-1(:type="hasTime && isValidDate && innerValue ? 'datetime' : 'date'", stylingMode="filled", 
		:editorOptions="{ seconds: false, minutesStep: 5 }", :placeholder="defaultValue || formattedValue", :editingMode="true", :value="dateValue", @change="onDateParamChanged", :preventChangeDateOnTimeChange="true")
		.flex-col.small-desc-holder(v-if="hasTimeZone", slot="end")
			Loader(v-if="!initiated", text="")
			template(v-else)
				.small-desc.upper {{$tCaption('Time zone')}}
				select.timezone-selector(@change="onTimeZoneSelectChange")
					option(v-for="item in timeZones", :value="timeZone.Id", :selected="timeZone && timeZone.Id === item.Id", @click="changeTimeZone(item)") {{item.Time}}
</template>

<script>
import DxDateBox from 'devextreme-vue/date-box';
import EditableLabelField from 'app-core/EditableLabelField.vue';
import Dropdown from 'app-core/Dropdown.vue';
import Loader from 'app-core/Loader.vue';

export default {
	translationCategory: 'webServiceCaller.DateEditor',
	components: { DxDateBox, EditableLabelField, Dropdown, Loader },
	props: ['value', 'hasTimeZone', 'hasTime', 'defaultValue'],
	data() {
		return {
			innerValue: this.value,
			timeZone: null,
			timeZones: [],
			initiated: false
		};
	},
	computed: {
		formattedValue() {
			return this.innerValue && this.isValidDate ? `${this.$moment(this.dateValue)?.format(this.hasTime ? 'YYYY-MM-DD HH:mm:ss' : (this.hasTimeZone ? 'YYYY-MM-DD 00:00:00' : 'YYYY-MM-DD'))}${this.hasTimeZone && this.innerValue && this.timeZone ? `${this.timeZone?.Time}` : ''}` 
				: `@RunDate${this.hasTimeZone ? `(${this.timeZone?.Time})` : ''}`;
		},
		dateValue() {
			return this.isValidDate ? this.$moment(this.innerValue, 'YYYY-MM-DDTHH:mm:ss').toDate() : null;
		},
		isValidDate() {
			return !isNaN(this.$moment(this.innerValue, 'YYYY-MM-DDTHH:mm:ss').toDate());
		}
	},
	watch: {
		value(v) {
			if (`${v}` !== `${this.innerValue}`) {
				if (__DEBUG__)
					console.debug('Set value', { v, cv: this.innerValue });
				this.innerValue = v;
				this.findTimeZone();
			}
		},
		hasTimeZone() {
			this.findTimeZone().then(() => this.checkDiff());
		},
		hasTime() {
			this.checkDiff();
		}
	},
	mounted() {
		if (__DEBUG__)
			window.serviceDateEditor = this;
		this.init().finally(() => this.initiated = true);
	},
	methods: {
		onTimeZoneSelectChange(e) {
			if (__DEBUG__)
				console.debug('onTimeZoneSelectChange', { e });
			this.changeTimeZone(this.timeZones[e.srcElement.selectedIndex]);
		},
		checkDiff() {
			setImmediate(() => {
				if (this.innerValue && this.innerValue !== this.formattedValue) {
					this.$emit('change', this.formattedValue);
				}
			});
		},
		async init() {
			this.timeZones = (await this.$Data.getTimeZonesTimes(0,999))?.Results;

			this.findTimeZone();
		},
		async findTimeZone() {
			if (this.hasTimeZone) {
				this.timeZone = null;
				if (`${this.innerValue}`.endsWith('Z'))
					this.timeZone = this.timeZones?.find(f => f.Time === '+00:00');
				if (!this.timeZone)
					this.timeZone = this.timeZones?.find(f => `${this.innerValue}`.indexOf(f.Time) > -1);
				if (!this.timeZone)
					this.timeZone = this.timeZones?.find(f => f.Time === this.$moment().format('Z'));
			}
		},
		onDateParamChanged(v) {
			if (`${this.innerValue}` !== `${v}` && (!v || v?.getMonth) && !isNaN(v)) {
				if (__DEBUG__)
					console.debug('onDateParamChanged', { v, getM: v?.getMonth });
				this.innerValue = v;
				this.$emit('change', this.formattedValue);
			}
		},
		changeTimeZone(item) {
			if (__DEBUG__)
				console.debug('onDateParamChanged timezone', { v: this.formattedValue });
			this.timeZone = item;
			this.$emit('change', this.formattedValue);
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.web-services--date-editor {
		.dx-overlay-content.dx-invalid-message-content {
			display: none !important;
		}
		.dx-invalid.dx-texteditor.dx-show-invalid-badge .dx-texteditor-input-container::after {
			display: none !important;
		}

		.timezone-selector {
			padding: 10px;
			border-radius: 4px;
			border: 0px solid #e9e9e9;
			background: #e9e9e9;
			color: #333;
			min-width: 90px;
			margin-bottom: 0px;

			/* Arrow */
			appearance: none;
			background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%236b6b6b%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
			background-repeat: no-repeat;
			background-position: right 0.7rem top 50%;
			background-size: 0.65rem auto;
			background-color: #e9e9e9;

			&:hover {
				color: #333;
				background-color: #e9e9e9;
			}

			&:active {
				background-image: linear-gradient(var(--accentFg), var(--accentFg)),
					linear-gradient(-135deg, transparent 50%, var(--accentFg) 50%),
					linear-gradient(-225deg, transparent 50%, var(--accentFg) 50%),
					linear-gradient(var(--accentFg) 42%, var(--accentBg) 42%);
				color: #333;
				background-color: #e9e9e9;
			}

			option {
				background: #e9e9e9;
				color: #333;
			}

			option[selected="selected"] {
				background: $base-accent;
				color: $base-bg;
			}
		}
	}
</style>
